/* import __COLOCATED_TEMPLATE__ from './client-provider-items.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentsGoodFaithEstimateClientProviderItems extends Component {}
